import Swal from 'sweetalert2'

// Escapa los caracteres especiales de HTML de un valor.
// Se usa antes de interpolar datos del servidor dentro de `html:` de SweetAlert2,
// que interpreta el contenido como HTML real (XSS almacenado).
const escapeHtml = (value) => {
    if (value === null || value === undefined) {
        return '';
    }
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

export function showSuccessAlert({ position = 'top-end', title, text, timer = 4500 }){
    return Swal.fire({
        icon: 'success',
        position,
        title,
        text,
        showConfirmButton: false,
        timer
    })
}

export function showWarningAlert({ position = 'top-end', title, text, timer = 4500 }){
    return Swal.fire({
        icon: 'warning',
        position,
        title,
        text,
        showConfirmButton: false,
        timer
    })
}

export function showErrorAlert({ position = 'top-end', title, text, timer = 4500 }){
    return Swal.fire({
        icon: 'error',
        position,
        title,
        text,
        showConfirmButton: false,
        timer
    })
}

export function showInfoAlert({ position = 'top-end', title, text, timer = 4500 }){
    return Swal.fire({
        icon: 'info',
        position,
        title,
        text,
        showConfirmButton: false,
        timer
    })
}

export function showAlert({ icon = 'info', position = 'top-end', title = '', text = '', timer = 4500 }){
    return Swal.fire({
        icon,
        position,
        title,
        text,
        showConfirmButton: false,
        timer
    })
}

export function showConfirmAlert({ title, text, icon = 'warning', confirmButtonText = 'Sí, confirmar!', cancelButtonText = 'Cancelar',
    confirmButtonColor = '#3085d6', cancelButtonColor = '#d33'
}) {
    return Swal.fire({
        icon,
        title,
        text,
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText,
        confirmButtonColor,
        cancelButtonColor
    });
}

// Confirmación con HTML. `html` es una plantilla con marcadores `{key}` que se
// sustituyen por el valor ESCAPADO de `data`. Así el marcado estático es
// escribible a mano mientras que los datos del servidor nunca se interpretan
// como HTML (XSS almacenado).
export function showConfirmAlertHtml({ title, html, data = {}, text, icon = 'warning',
    confirmButtonText = 'Sí, confirmar!', cancelButtonText = 'Cancelar',
    confirmButtonColor = '#3085d6', cancelButtonColor = '#d33'
}) {
    const rendered = Object.keys(data).reduce((acc, key) => {
        const placeholder = new RegExp(`\\{${key}\\}`, 'g');
        return acc.replace(placeholder, escapeHtml(data[key]));
    }, html || '');

    return Swal.fire({
        icon,
        title,
        html: rendered,
        text,
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText,
        confirmButtonColor,
        cancelButtonColor
    });
}

export { escapeHtml }
